class DataLayerService {
  //Calculate the values
  productRevenueDetails(selectProduct, quote, serviceType) {
    let metric3 = 0;
    let metric4 = 0;
    let revenue = 0;
    let products = [];

    let productPackage = {
      'id': undefined,
      'name': undefined,
      'price': undefined,
      'quantity': 1,
      'metric1': undefined,
      'metric2': undefined,
      'category': undefined,
      'variant': undefined,
      'dimension1': undefined,
      'dimension2': undefined
    };
    //For commercial product
    if (serviceType !== null && serviceType === 'Commercial') {
      for (let index = 0; index < selectProduct.configuration.packages.length; index++) {
        let item = selectProduct.configuration.packages[index];
        productPackage = {
          'id': undefined,
          'name': undefined,
          'price': undefined,
          'quantity': 1,
          'metric1': undefined,
          'metric2': undefined,
          'category': undefined,
          'variant': undefined,
          'dimension1': undefined,
          'dimension2': undefined
        };

        if (item.package === 'lease_expiry_diary') {
          productPackage.id = 'LED';
          productPackage.name = 'Lease Expiry Diary';
          productPackage.variant = 'Lease Expiry Diary';
          productPackage.price = parseFloat(((quote.lineItems[index].total / 1.1) * 41).toFixed(2));
        } else if (item.package === 'cityscope') {
          productPackage.id = 'Cityscope';
          productPackage.name = 'Cityscope';
          productPackage.variant = 'Cityscope';
          productPackage.price = parseFloat(((quote.lineItems[index].total / 1.1) * 51).toFixed(2));
        } else if (item.package === 'combo') {
          productPackage.id = 'Cityscope+LED';
          productPackage.name = 'Cityscope+Lease Expiry Diary';
          productPackage.variant = 'Cityscope + Lease Expiry Diary';
          productPackage.price = parseFloat(((quote.lineItems[index].total / 1.1) * 48).toFixed(2));
        }
        productPackage.metric1 = parseFloat((quote.lineItems[index].total / 1.1).toFixed(2));
        productPackage.metric2 = parseFloat(((quote.lineItems[index].total / 1.1) * 12).toFixed(2));
        productPackage.dimension1 = item.number_of_users.toString();
        productPackage.dimension2 = `1 - ${item.location.state.toUpperCase()}`;
        revenue = revenue + productPackage.price;
        metric3 = metric3 + productPackage.metric1;
        metric4 = metric4 + productPackage.metric2;
        products.push(productPackage);
      }
    }

    //for cordell product
    else if (serviceType !== null && serviceType === 'CordellConnect') {
      selectProduct = selectProduct.configuration;
      productPackage.id = 'Connect';
      productPackage.name = 'Cordell Connect';

      productPackage.metric1 = parseFloat((quote.totalPerMonth / 1.1).toFixed(2));
      productPackage.metric2 = parseFloat(((quote.totalPerMonth / 1.1) * 12).toFixed(2));
      productPackage.price = parseFloat(((quote.totalPerMonth / 1.1) * 37).toFixed(2));
      productPackage.variant = 'Connect Lite';

      productPackage.dimension1 = selectProduct.number_of_users.toString();
      if (selectProduct.geography.states !== null && selectProduct.geography.states.length > 0) {
        let stateNames = '';
        for (let i = 0; i < selectProduct.geography.states.length; i++) {
          stateNames = stateNames + selectProduct.geography.states[i].toUpperCase();
          if (i < selectProduct.geography.states.length - 1) {
            stateNames = `${stateNames},`;
          }
        }
        productPackage.dimension2 = `${selectProduct.geography.states.length} - ${stateNames}`;
      }
      revenue = revenue + productPackage.price;
      metric3 = metric3 + productPackage.metric1;
      metric4 = metric4 + productPackage.metric2;
      products.push(productPackage);
    }

    //for rpp product
    else if (serviceType !== null && serviceType === 'RPPRealEstate') {
      let addonsDetails = {
        'real_estate_agencies_and_valuers': {
          'starter': [
            {
              'name': 'Marketing Direct',
              'price': 143.0
            },
            {
              'name': 'Agency Benchmark',
              'price': 22.0
            },
            {
              'name': 'Chinese Language Reports',
              'price': 22.0
            },
            {
              'name': 'Media Maximiser',
              'price': 22.0
            },
            {
              'name': 'Blockbrief Premier',
              'price': 75.9
            },
            {
              'name': 'Blockbrief Pro',
              'price': 143.0
            },
            {
              'name': 'HomePrezzo Agent',
              'price': 54.0
            }
          ],
          'essentials': [
            {
              'name': 'Marketing Direct',
              'price': 143.0
            },
            {
              'name': 'Agency Benchmark',
              'price': 22.0
            },
            {
              'name': 'Chinese Language Reports',
              'price': 22.0
            },
            {
              'name': 'Media Maximiser',
              'price': 22.0
            },
            {
              'name': 'Blockbrief Premier',
              'price': 75.9
            },
            {
              'name': 'Blockbrief Pro',
              'price': 143.0
            },
            {
              'name': 'HomePrezzo Small Agency',
              'price': 165.0
            },
            {
              'name': 'HomePrezzo Agency',
              'price': 232.0
            },
            {
              'name': 'HomePrezzo Agency Large',
              'price': 396.0
            }
          ]
        },
        'investors': {
          'basic': [
            {
              'name': 'Chinese Language Reports',
              'price': 22.0
            },
            {
              'name': 'Blockbrief Premier',
              'price': 75.9
            },
            {
              'name': 'Blockbrief Pro',
              'price': 143.0
            }
          ]
        },
        'mortgage_brokers_and_financial_planners': {
          'pro': [
            {
              'name': 'Marketing Direct',
              'price': 132.0
            },
            {
              'name': 'Chinese Language Reports',
              'price': 22.0
            },
            {
              'name': 'Blockbrief Premier',
              'price': 75.9
            },
            {
              'name': 'Blockbrief Pro',
              'price': 143.0
            },
            {
              'name': 'HomePrezzo Agent Lite',
              'price': 22.0
            }
          ],
          'basic': [
            {
              'name': 'Marketing Direct',
              'price': 143.0
            },
            {
              'name': 'Chinese Language Reports',
              'price': 22.0
            },
            {
              'name': 'HomePrezzo Agent',
              'price': 54.0
            }
          ]
        },
        'property_developers_trades_services': {
          'basic': [
            {
              'name': 'Marketing Direct',
              'price': 143.0
            },
            {
              'name': 'Chinese Language Reports',
              'price': 22.0
            },
            {
              'name': 'Blockbrief Premier',
              'price': 75.9
            },
            {
              'name': 'Blockbrief Pro',
              'price': 143.0
            }
          ]
        }
      };
      selectProduct = selectProduct.configuration;
      productPackage.id = 'RPP';
      productPackage.name = 'RP Data';
      let addonsPrice = 0;
      if (selectProduct.addons && selectProduct.addons.length > 0) {
        for (let addonIndex = 0; addonIndex < selectProduct.addons.length; addonIndex++) {
          let addon = selectProduct.addons[addonIndex];
          let addonslist = addonsDetails[selectProduct.industry][selectProduct.package];
          if (addonslist) {
            for (let itemIndex = 0; itemIndex < addonslist.length; itemIndex++) {
              let addonitem = addonslist[itemIndex];
              if (addon === addonitem.name) {
                addonsPrice = addonsPrice + addonitem.price;
              }
            }
          }
        }

        if (addonsPrice > 0) {
          productPackage.metric1 = parseFloat(
            ((quote.totalPerMonth - addonsPrice) / 1.1).toFixed(2)
          );
          productPackage.metric2 = parseFloat(
            (((quote.totalPerMonth - addonsPrice) / 1.1) * 12).toFixed(2)
          );
        }
      } else {
        productPackage.metric1 = parseFloat((quote.totalPerMonth / 1.1).toFixed(2));
        productPackage.metric2 = parseFloat(((quote.totalPerMonth / 1.1) * 12).toFixed(2));
      }

      if (selectProduct.industry === 'real_estate_agencies_and_valuers') {
        if (selectProduct.package === 'starter') {
          productPackage.variant = 'RPP Starter';
        } else if (selectProduct.package === 'essentials') {
          productPackage.variant = 'RPP Essentials';
        }
        productPackage.price = parseFloat(
          (((quote.totalPerMonth - addonsPrice) / 1.1) * 60).toFixed(2)
        );
        productPackage.category = 'Agents';
        //   category = "Agents"
      } else if (selectProduct.industry === 'mortgage_brokers_and_financial_planners') {
        if (selectProduct.package === 'pro') {
          productPackage.variant = 'RPP Broker';
        } else if (selectProduct.package === 'basic') {
          productPackage.variant = 'RPP Advisor';
        }
        productPackage.price = parseFloat(
          (((quote.totalPerMonth - addonsPrice) / 1.1) * 24).toFixed(2)
        );
        productPackage.category = 'Brokers';
        //   category = "Brokers"
      } else if (selectProduct.industry === 'investors') {
        if (selectProduct.package === 'basic') {
          productPackage.variant = 'RPP Starter';
        } else if (selectProduct.package === 'one_month') {
          productPackage.variant = 'RPP 1 Month';
          productPackage.metric2 = parseFloat(
            ((quote.totalPerMonth - addonsPrice) / 1.1).toFixed(2)
          );
        }
        productPackage.price = parseFloat(
          (((quote.totalPerMonth - addonsPrice) / 1.1) * 12).toFixed(2)
        );
        productPackage.category = 'Investors';
        //   category = "Investors"
      } else if (selectProduct.industry === 'property_developers_trades_services') {
        if (selectProduct.package === 'basic') {
          productPackage.variant = 'RPP Starter';
        }
        productPackage.price = parseFloat(
          (((quote.totalPerMonth - addonsPrice) / 1.1) * 42).toFixed(2)
        );
        productPackage.category = 'Others';
        //   category = "Others"
      }
      //
      if (selectProduct.package === 'trial') {
        productPackage.variant = 'RPP Trial';
        productPackage.dimension2 = '0';
        if (selectProduct.industry === 'investors') {
          productPackage.metric2 = 35.88;
          productPackage.price = 35.88;
        } else {
          productPackage.metric2 = 187.32;
          productPackage.price = 655.62;
        }
      }
      productPackage.dimension1 = selectProduct.number_of_users.toString();
      if (selectProduct.geography.national === true) {
        productPackage.dimension2 = '8 - National';
      } else if (
        selectProduct.geography.states !== null &&
        selectProduct.geography.states.length > 0
      ) {
        let statesNames = '';
        for (let stateindex = 0; stateindex < selectProduct.geography.states.length; stateindex++) {
          statesNames = statesNames + selectProduct.geography.states[stateindex];
          if (stateindex < selectProduct.geography.states.length - 1) {
            statesNames = `${statesNames},`;
          }
        }
        productPackage.dimension2 = `${selectProduct.geography.states.length} - ${statesNames}`;
      }

      revenue = revenue + productPackage.price;
      metric3 = metric3 + productPackage.metric1;
      metric4 = metric4 + productPackage.metric2;
      products.push(productPackage);

      if (selectProduct.addons && selectProduct.addons.length > 0) {
        for (let addonIndx = 0; addonIndx < selectProduct.addons.length; addonIndx++) {
          let selectedAddon = selectProduct.addons[addonIndx];
          productPackage = {
            'name': selectedAddon,
            'id': undefined,
            'price': undefined,
            'category': undefined,
            'quantity': 1,
            'metric1': undefined,
            'metric2': undefined
          };

          if (selectedAddon === 'Marketing Direct') {
            productPackage.id = 'Addon-MD';
          } else if (selectedAddon === 'Agency Benchmark') {
            productPackage.id = 'Addon-AB';
          } else if (selectedAddon === 'Chinese Language Reports') {
            productPackage.id = 'Addon-CLR';
          } else if (selectedAddon === 'Media Maximiser') {
            productPackage.id = 'Addon-MM';
          } else if (selectedAddon === 'Blockbrief Premier') {
            productPackage.id = 'Addon-BB';
          } else if (selectedAddon === 'Blockbrief Pro') {
            productPackage.id = 'Addon-BBP';
          } else if (selectedAddon === 'HomePrezzo Agent') {
            productPackage.id = 'Addon-HPAgent';
          } else if (selectedAddon === 'HomePrezzo Agent Lite') {
            productPackage.id = 'Addon-HPAgentL';
          } else if (selectedAddon === 'HomePrezzo Small Agency') {
            productPackage.id = 'Addon-HPSA';
          } else if (selectedAddon === 'HomePrezzo Agency') {
            productPackage.id = 'Addon-HPAgency';
          } else if (selectedAddon === 'HomePrezzo Agency Large') {
            productPackage.id = 'Addon-HPAgencyL';
          }

          let addonItems = addonsDetails[selectProduct.industry][selectProduct.package];
          for (let addonItemIndex = 0; addonItemIndex < addonItems.length; addonItemIndex++) {
            let addonItem = addonItems[addonItemIndex];
            if (selectedAddon === addonItem.name) {
              productPackage.metric1 = parseFloat((addonItem.price / 1.1).toFixed(2));
              productPackage.metric2 = parseFloat(((addonItem.price / 1.1) * 12).toFixed(2));
            }
          }

          if (selectProduct.industry === 'real_estate_agencies_and_valuers') {
            productPackage.price = parseFloat((productPackage.metric1 * 60).toFixed(2));
            productPackage.category = 'Agents';
          } else if (selectProduct.industry === 'mortgage_brokers_and_financial_planners') {
            productPackage.price = parseFloat((productPackage.metric1 * 24).toFixed(2));
            productPackage.category = 'Brokers';
          } else if (selectProduct.industry === 'investors') {
            productPackage.category = 'Investors';
            productPackage.price = parseFloat((productPackage.metric1 * 12).toFixed(2));
          } else if (selectProduct.industry === 'property_developers_trades_services') {
            productPackage.price = parseFloat((productPackage.metric1 * 42).toFixed(2));
            productPackage.category = 'Others';
          }

          products.push(productPackage);
        }
      }
    }

    //blockbrief
    else if (serviceType !== null && serviceType === 'Blockbrief') {
      selectProduct = selectProduct.configuration;
      productPackage.id = 'Blockbrief';
      productPackage.name = 'Blockbrief';
      productPackage.price = parseFloat(((quote.totalPerMonth / 1.1) * 30).toFixed(2));
      productPackage.metric1 = parseFloat((quote.totalPerMonth / 1.1).toFixed(2));
      productPackage.metric2 = parseFloat(((quote.totalPerMonth / 1.1) * 12).toFixed(2));
      productPackage.dimension1 = selectProduct.number_of_users.toString();
      productPackage.dimension2 = '0';
      if (selectProduct.package === 'premier_pro') {
        productPackage.variant = 'Blockbrief Pro';
      } else if (selectProduct.package === 'premier') {
        productPackage.variant = 'Blockbrief Base';
      }
      metric3 = metric3 + productPackage.metric1;
      metric4 = metric4 + productPackage.metric2;
      revenue = revenue + productPackage.price;
      products.push(productPackage);
    }

    //report bundle
    else if (serviceType !== null && serviceType === 'ReportBundle') {
      selectProduct = selectProduct.configuration;
      productPackage.id = 'ReportBundle';
      productPackage.name = 'Report Bundle';
      productPackage.price = parseFloat(((quote.totalPerMonth / 1.1) * 20).toFixed(2));
      productPackage.metric1 = parseFloat((quote.totalPerMonth / 1.1).toFixed(2));
      productPackage.metric2 = parseFloat(((quote.totalPerMonth / 1.1) * 12).toFixed(2));
      productPackage.dimension1 = '1';
      if (selectProduct.packageName === 'residential') {
        productPackage.variant = 'Residential Report Bundle';
      } else if (selectProduct.packageName === 'investors_premium') {
        productPackage.variant = 'Investor Report Bundle';
      } else if (selectProduct.packageName === 'property_developers_and_construction') {
        productPackage.variant = 'Developer Construction Report Bundle';
      }
      metric3 = metric3 + productPackage.metric1;
      metric4 = metric4 + productPackage.metric2;
      revenue = revenue + productPackage.price;
      if (selectProduct.geography.states && selectProduct.geography.states.length > 0) {
        let geoStateNames = '';
        for (let stateIndex = 0; stateIndex < selectProduct.geography.states.length; stateIndex++) {
          geoStateNames = geoStateNames + selectProduct.geography.states[stateIndex];
          if (stateIndex < selectProduct.geography.states.length - 1) {
            geoStateNames = `${geoStateNames},`;
          }
        }
        productPackage.dimension2 = `${selectProduct.geography.states.length} - ${geoStateNames}`;
      }
      products.push(productPackage);
    }

    //EMI
    else if (serviceType !== null && serviceType === 'EarlyMarketIndicator') {
      selectProduct = selectProduct.configuration;
      productPackage.id = 'EarlyMarketIndicator';
      productPackage.name = 'Early Market Indicator';
      productPackage.price = parseFloat(((quote.totalPerMonth / 1.1) * 20).toFixed(2));
      productPackage.metric1 = parseFloat((quote.totalPerMonth / 1.1).toFixed(2));
      productPackage.metric2 = parseFloat(((quote.totalPerMonth / 1.1) * 12).toFixed(2));
      productPackage.dimension1 = '1';
      if (selectProduct.package === 'premium') {
        productPackage.variant = 'Premium Early Market Indicator';
      }
      metric3 = metric3 + productPackage.metric1;
      metric4 = metric4 + productPackage.metric2;
      revenue = revenue + productPackage.price;
      products.push(productPackage);
    }

    //for cordell estimator
    else if (serviceType !== null && serviceType === 'CordellEstimator') {
      let estimatorAddonsDetails = [
        {
          'name': 'Planswift',
          'price': 219.54
        }
      ];
      selectProduct = selectProduct.configuration;
      productPackage.name = 'Estimator Platinum';
      if (selectProduct.packageName === 'cordell_estimator_platinum_lite') {
        productPackage.variant = 'Estimator Lite';
        productPackage.id = 'CEPL';
      } else if (selectProduct.packageName === 'cordell_estimator_platinum') {
        productPackage.variant = 'Platinum';
        productPackage.id = 'CEP';
      }
      let estimatorAddonsPrice = 0;
      if (selectProduct.addons && selectProduct.addons.length > 0) {
        for (
          let estimatorAddonIndex = 0;
          estimatorAddonIndex < selectProduct.addons.length;
          estimatorAddonIndex++
        ) {
          let adEstimator = selectProduct.addons[estimatorAddonIndex];
          for (let iIndex = 0; iIndex < estimatorAddonsDetails.length; iIndex++) {
            let adnitem = estimatorAddonsDetails[iIndex];
            if (adEstimator === adnitem.name) {
              estimatorAddonsPrice = estimatorAddonsPrice + adnitem.price;
            }
          }
        }
        if (estimatorAddonsPrice > 0) {
          productPackage.metric1 = parseFloat(
            ((quote.totalPerMonth - estimatorAddonsPrice) / 1.1).toFixed(2)
          );
          productPackage.metric2 = parseFloat(
            (((quote.totalPerMonth - estimatorAddonsPrice) / 1.1) * 12).toFixed(2)
          );
        }
      } else {
        productPackage.metric1 = parseFloat((quote.totalPerMonth / 1.1).toFixed(2));
        productPackage.metric2 = parseFloat(((quote.totalPerMonth / 1.1) * 12).toFixed(2));
      }

      productPackage.price = parseFloat(
        (((quote.totalPerMonth - estimatorAddonsPrice) / 1.1) * 48).toFixed(2)
      );

      productPackage.dimension1 = selectProduct.numberOfUsers.toString();
      if (selectProduct.geography.national === true) {
        productPackage.dimension2 = '8 - National';
      } else if (
        selectProduct.geography.states !== null &&
        selectProduct.geography.states.length > 0
      ) {
        let stNames = '';
        for (let stIndex = 0; stIndex < selectProduct.geography.states.length; stIndex++) {
          stNames = stNames + selectProduct.geography.states[stIndex];
          if (stIndex < selectProduct.geography.states.length - 1) {
            stNames = `${stNames},`;
          }
        }
        productPackage.dimension2 = `${selectProduct.geography.states.length} - ${stNames}`;
      }

      revenue = revenue + productPackage.price;
      metric3 = metric3 + productPackage.metric1;
      metric4 = metric4 + productPackage.metric2;
      products.push(productPackage);

      if (selectProduct.addons && selectProduct.addons.length > 0) {
        for (
          let estimatorAddonIndx = 0;
          estimatorAddonIndx < selectProduct.addons.length;
          estimatorAddonIndx++
        ) {
          let selectedAd = selectProduct.addons[estimatorAddonIndx];
          productPackage = {
            'name': selectedAd,
            'id': undefined,
            'price': undefined,
            'category': undefined,
            'quantity': 1,
            'metric1': undefined,
            'metric2': undefined
          };

          if (selectedAd === 'Planswift') {
            productPackage.id = 'Addon-Planswift';
          }

          let adItems = estimatorAddonsDetails;
          for (let adItemIndex = 0; adItemIndex < adItems.length; adItemIndex++) {
            let adItem = adItems[adItemIndex];
            if (selectedAd === adItem.name) {
              productPackage.metric1 = parseFloat((adItem.price / 1.1).toFixed(2));
              productPackage.metric2 = parseFloat(((adItem.price / 1.1) * 12).toFixed(2));
            }
          }
          productPackage.price = parseFloat((productPackage.metric1 * 48).toFixed(2));

          products.push(productPackage);
        }
      }
    }

    let productValues = {
      'products': products,
      'revenue': revenue,
      'metric3': metric3,
      'metric4': metric4
    };

    return productValues;
  }

  // Script 1
  notifyOnNewCartItem(item, configuration) {
    item.quote.quotes.map(
      function (subItem, subIndex) {
        if (subItem.productId === configuration.product_id) {
          let productDetails = this.productRevenueDetails(configuration, subItem, subItem.type);
          window.dataLayer.push({
            'event': 'addToCart',
            'ecommerce': {
              'add': {
                'products': productDetails.products
              }
            }
          });
        }
      }.bind(this)
    );
  }

  // Script 2
  notifyOnDeleteCartItem(item) {
    if (item !== undefined) {
      let productDetails = this.productRevenueDetails(item.configuration, item, item.type);
      for (let index = 0; index < productDetails.products.length; index++) {
        let product = productDetails.products[index];
        window.dataLayer.push({
          'event': 'removeFromCart',
          'ecommerce': {
            'remove': {
              'products': [
                {
                  'name': product.name,
                  'id': product.id,
                  'price': product.price,
                  'category': product.category,
                  'variant': product.variant,
                  'quantity': product.quantity,
                  'dimension1': product.dimension1,
                  'dimension2': product.dimension2
                }
              ]
            }
          }
        });
      }
    }
  }

  //Script 3
  notifyOnCheckout(data) {
    if (
      data.order &&
      data.order.quotes &&
      data.order.quotes.quotes &&
      data.order.quotes.quotes.length > 0
    ) {
      let serviceType = undefined;
      let productDetails = {};
      let products = [];

      data.order.quotes.quotes.map(
        function (quote, index) {
          data.order.quoteConfiguration.products.map(
            function (quoteConfig, quoteConfigIndex) {
              if (quoteConfig.product_id === quote.productId) {
                serviceType = quote.type;
                productDetails = this.productRevenueDetails(quoteConfig, quote, serviceType);
                for (let subIndex = 0; subIndex < productDetails.products.length; subIndex++) {
                  let product = productDetails.products[subIndex];
                  products.push(product);
                }
              }
            }.bind(this)
          );
        }.bind(this)
      );

      window.dataLayer.push({
        'event': 'checkout',
        'ecommerce': {
          'checkout': {
            'actionField': { 'step': 1 },
            'products': products
          }
        }
      });
    }
  }
}

export default DataLayerService;
